import React, { Fragment } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import RolesTable from "./RolesTable";
import "./style.scss";

const RoleManagementPage = () => (
  <Fragment>
    <Container fluid={true} style={{ paddingTop: "30px" }}>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody style={{ padding: "15px" }}>
              <RolesTable />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  </Fragment>
);

export default RoleManagementPage;
